import { chaptersMapper } from "../Chapter/normalizer";

export const audioBookMapper = audioBook => ({
  id: audioBook.id,
  name: audioBook.name,
  author: audioBook.author,
  isbn: audioBook.isbn,
  publisher: audioBook.publisher,
  book: bookMapper(audioBook.book),
  chapters: audioBook.chapters ? chaptersMapper(audioBook.chapters) : null,
});

const bookMapper = book => ({
  id: book.id,
  title: book.title
});